import PlusIcon from '@/shared/assets/plus-icon.svg?react';
import { useTranslation } from 'react-i18next';
import { type ComponentProps } from 'react';
import { cn } from '@/shared/utils';

const AccountCardCreateNew = ({
  onClick,
  className,
  disabled,
  description,
  ...props
}: ComponentProps<'div'> & { disabled?: boolean; description?: string }) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'group hover:bg-stroke-light-bg hover:cursor-pointer flex flex-col items-center justify-center gap-[1.2rem] p-[2.4rem_2.1rem] w-[30rem] h-[16rem] account-open-card-border border-tertiary rounded-[2.4rem]',
        disabled && 'pointer-events-none',
        className
      )}
      onClick={disabled ? undefined : onClick}
      {...props}>
      <PlusIcon className="text-secondary size-[2.4rem] group-hover:text-primary" />
      <div>
        <h4 className="headline4 text-secondary text-center mb-[0.4rem] group-hover:text-primary">
          {t('personalAccount.accountsSection.openAccountTitle')}
        </h4>
        <p className="p5 text-secondary text-center">
          {description ??
            t('personalAccount.accountsSection.openAccountDescription')}
        </p>
      </div>
    </div>
  );
};

export { AccountCardCreateNew };
